import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import "./../../UaeAttestation/UaeService/UaeService.css";
const PhilippinesServiceMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          In June 2020, the Philippines signed the Hague Convention Abolishing
          the legalization requirements for foreign public documents. Since
          then, the Attestation procedure has been used to authorize the use of
          foreign documents in the Philippines. To confirm its authenticity and
          legitimacy, any foreign-official document intended for use in the
          Philippines must first obtain the Philippines documents Attestation.
          The concerned authorities validate and legalize papers as part of the
          process.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          To obtain an Attestation stamp, you must obtain verification from all
          relevant agencies. All government-issued documents (educational,
          non-educational, and commercial) intended for use in the Philippines
          must be Attestationd. GOODWAY ATTESTATION provides great and
          affordable Philippines Attestation services in Bangalore. Choosing an
          appropriate agency to complete the process makes a difference because
          it is less complicated and the individuals doing this process are
          specialists.
        </li>
      </ul>
    </div>
  );
};

export default PhilippinesServiceMain;
